/**
 * React Query key constants for run-engine state. Centralised so every
 * hook + mutation invalidates the same key family when a run starts /
 * cancels / terminates and the editor + Runs tab refresh in lockstep.
 */
const PROCESS_RUNS_KEY_ROOT = ['processes', 'runs'] as const;

/** Family root -- pass to {@code invalidateQueries} to refresh every run-related query. */
export const processRunsRootKey = (): readonly unknown[] => [
  ...PROCESS_RUNS_KEY_ROOT,
];

/** Cache key for the run list of a single process (Runs tab badge + future history table). */
export const processRunsListQueryKey = (
  processId: string,
  params?: Readonly<Record<string, unknown>>,
): readonly unknown[] => [
  ...PROCESS_RUNS_KEY_ROOT,
  'list',
  processId,
  params ?? null,
];

/** Cache key for a single run's detail (per-node states + gate decisions). */
export const processRunDetailQueryKey = (
  processId: string,
  runId: string,
): readonly unknown[] => [
  ...PROCESS_RUNS_KEY_ROOT,
  'detail',
  processId,
  runId,
];
